/** @jsxImportSource @emotion/react */
import { string } from 'prop-types';
import { useTokens } from '@nike/nike-design-system-components';

const ImageLabelOverlay = ({ text }) => {
  const tokens = useTokens();

  return (
    <div
      css={{
        width: '100%',
        textAlign: 'center',
        background: tokens.podiumCdsColorGrey200,
        padding: '10px 0',
        position: 'absolute',
        top: '196px',
        right: 0
      }}
    >
      {text}
    </div>
  );
};

ImageLabelOverlay.propTypes = {
  text: string.isRequired
};

export default ImageLabelOverlay;
